import React, { Component } from 'react'
import { connect } from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import LocationInput2 from '~/components/common/LocationInput2';
import LabeledInput from '../LabeledInput';
import css from './index.css'
import Button from '~/components/common/Button';
import cs from 'classnames'
import { getDistance } from '~/api/map'
import { modalChange } from '~/modules/modal/actions';
import accounting from '~/misc/accounting';
import FuelCostHint from './components/FuelCostHint';
// import LocalStorage from 'localstorage'
// const LocalStorage = require('localstorage')

class LocalStorage {
  constructor (namespace) {
    this._namespace = namespace
    this._store = window.localStorage
    this._sep = '\x00'
  }

  static clear () {
    window.localStorage.clear()
  }

  _notFound (k) {
    const err = new Error(`Not Found [${k}]`)
    err.notFound = true
    err.key = k
    return err
  }

  get (key) {
    const k = [this._namespace, key].join(this._sep)
    if (!this._store[k]) return [this._notFound(k)]

    try {
      return [null, JSON.parse(this._store[k])]
    } catch (err) {
      return [err]
    }
  }

  put (key, value) {
    if (typeof value === 'undefined') {
      return [new Error(`Invalid parameters to put, ('${key}', undefined)`)]
    }

    try {
      const k = [this._namespace, key].join(this._sep)
      const v = JSON.stringify(value)
      const result = this._store[k] = v
      return [null, result]
    } catch (err) {
      return [err]
    }
  }

  has (key) {
    const k = [this._namespace, key].join(this._sep)
    if (!this._store[k]) return [this._notFound(k)]
    return [null, true]
  }

  del (key) {
    if (key) {
      const k = [this._namespace, key].join(this._sep)
      if (!this._store[k]) return [this._notFound(k)]

      delete this._store[k]
      return [null]
    }

    Object.keys(window.localStorage).forEach(k => {
      const ns = k.split(this._sep)[0]
      if (ns === this._namespace) {
        delete this._store[k]
      }
    })
  }

  search (pattern) {
    if (!pattern) {
      throw new Error('A pattern is required')
    }

    const matchKeys = key => {
      const [, _key] = key.split(this._sep)

      if (!_key) return
      if (!pattern.test(_key)) return

      return key
    }

    const makePairs = key => ({
      key: key.split(this._sep)[1],
      value: this._store[key]
    })

    return [null, Object
      .keys(this._store)
      .filter(matchKeys)
      .map(makePairs)]
  }
}

const text = {
  empty: "This field is required!",
  dot: {
    wrong: "Not a valid DOT!",
    invaild: "Not a valid DOT!",
  },
  termOfService: {
    empty: "Please read and accept our terms.",
  },
  stripeTerm: {
    empty: "Please read and accept our terms.",
  },
  email: {
    wrong: "Enter a valid email!",
  },
  phone: {
    wrong: "Enter a valid phone number!",
  },
  firstName: {
    wrong: "20 char limit",
  },
  lastName: {
    wrong: "20 char limit",
  },
}

const formatNumber = (number,isMember) => {
  if(!(typeof(number)==='number') && isMember) return "---";
  if(!(typeof(number)==='number')) return "***";
  return accounting.formatNumber(number, 2)
}

const Unlock = ({
  onClick
})=>{
  return (
    <div className={css.resultUnlock} onClick={(onClick)}>
      <div className={css.resultUnlockIcon}></div>
      <span>Unlock</span>  
    </div>
  )
}

class FuelSurcharge extends Component {
  constructor(props){
    super(props);
    this.state = {
      distance: props.distance || "",
      fuelPrice:"3.0",
      basePrice: "2.8",
      milesPrice: "5.5",
      withLocation: false,
      error: {
        fuelPrice: "",
        basePrice: "",
        milesPrice: "",
      },
      estFuelPerMile: "",
      estFuelCost: "",
      fuelRateMile:"",
      totalFuel: "",
      loading: false,
    }
    if(!props.distance) {
      this.state.origin = ""
      this.state.destination = ""
      this.state.error.origin = ""
      this.state.error.destination = ""
      this.state.withLocation = true;
    }
  }
  componentDidMount() {
    
    const { withLocation } = this.state;
    
    if(!withLocation) {
      this.calculate();
    }else{
      this.getDataFromLocalStorage()
    }
    
  }
  setFormValue = (key, value) => {
    this.setState({
      [key]: value
    })
  };
  setError = (key, value) => {
    this.setState(
      {
        error: {
          ...this.state.error,
          [key]: value,
        },
      },
    );
  };
  checkField = (key) => {
    const value = this.state[key];
    switch (key) {
      case "email": {
        if (!regEmail.test(value)) {
          return text.email.wrong;
        }
        break;
      }
      case "firstName":
      case "lastName": {
        if (value.length > 20) {
          return text.firstName.wrong;
        }
        break;
      }
    }
  };
  checkFieldEmpty = (key) => {
    if (this.state[key] == false) {
      return (text[key] && text[key].empty) || text.empty;
    }
  };
  checkSingleField = (key) => {
    let error = {
      ...this.state.error,
    };
    error[key] = this.checkFieldEmpty(key) || this.checkField(key);
    this.setState({
      error,
    });
  };
  
  checkAllField = () => {
    const { error: errorOrigin } = this.state;
    let error = {};
    //special check
    Object.keys(errorOrigin).map((key) => {
      error[key] = this.checkField(key);
    });
    // empty value check
    Object.keys(errorOrigin).map((key) => {
      if (this.state[key] == false) {
        error[key] = this.checkFieldEmpty(key);
      }
    });
    this.setState({
      error,
    });
    return Object.values(error).some((e) => e);
  };

  suffixZero(value,suffix){
    return Number(value).toFixed(suffix)
  }
  handleChange = (key, value) => {
    this.setFormValue(key, value);
  };
  handleFuelPriceInputMount = (input) => {
    this.setState({
      fuelPriceInput:input
    })
  }
  handleFuelPriceHintClick = () => {
    this.state.fuelPriceInput.focus()
  }


  handleBlur = (key, value) => {
    this.checkSingleField(key);
    // if ((key == 'fuelPrice' || key == 'basePrice' || key == 'milesPrice') && value) {
    //   this.setState({
    //     [key]: this.suffixZero(value,2)
    //   })
    // }

  };

  calculate = () => {
    const {
      fuelPrice,
      milesPrice,
      distance,
      basePrice
    } = this.state;
    this.setState({
      estFuelPerMile: fuelPrice / milesPrice * distance,
      estFuelCost: fuelPrice / milesPrice,
      fuelRateMile: (fuelPrice - basePrice) / milesPrice,
      totalFuel: (fuelPrice - basePrice) / milesPrice * distance,
    });
  }

  handleSubmit = () => {
    const { isMember, showUpgradeToPremium } = this.props;
    
   
    if(!isMember){
      return showUpgradeToPremium();
    } 
    const error = this.checkAllField();
    if (error) return;
    const {
      origin,
      destination,
      withLocation
    } = this.state;
    if(!withLocation) {
      return this.calculate()
    }
    this.setState({
      loading: true,
    })
    getDistance(origin, destination).then(distance=> {
      this.saveDataToStorage()
      this.setState({distance, loading: false}, ()=>{
        this.calculate()
      });
    })
  }
  getDataFromLocalStorage(){
    this.setState({
      fuelLocalStorage:new LocalStorage('fuelLocalStorage')
    },() => {
      const {fuelLocalStorage} = this.state
      const [originErr,hasOrigin] = fuelLocalStorage.has('origin')
      const [destinationErr,hasDestination] = fuelLocalStorage.has('destination')
      if(hasOrigin && hasDestination){
        const [orginGetErr,origin] = fuelLocalStorage.get('origin')
        const [destinationGetErr,destination] = fuelLocalStorage.get('destination')
        const [fuelPriceErr,fuelPrice] = fuelLocalStorage.get('fuelPrice')
        const [milesPriceErr,milesPrice] = fuelLocalStorage.get('milesPrice')
        const [basePriceErr,basePrice] = fuelLocalStorage.get('basePrice')
        this.setState({
          origin,
          destination,
          fuelPrice,
          milesPrice,
          basePrice,
          hasOrigin,
          hasDestination
        },() => {
          // local storage pass data to state success
          console.log('getDataFromLocalStorage call back',this.state);
          
        })
        
      }else{
        // do nothing
      }
    })
  }
  saveDataToStorage(){
    const { fuelLocalStorage, origin, destination, fuelPrice, milesPrice, basePrice } = this.state
    fuelLocalStorage.put('origin',origin)
    fuelLocalStorage.put('destination',destination)
    fuelLocalStorage.put('fuelPrice',fuelPrice)
    fuelLocalStorage.put('milesPrice',milesPrice)
    fuelLocalStorage.put('basePrice',basePrice)
  }
  renderForm () {
    const id = 1;
    const { 
      error,
      origin,
      destination,
      fuelPrice, 
      basePrice, 
      milesPrice,
      withLocation,
      hasOrigin,
      hasDestination
    } = this.state;
    return (
      <div className={css.FormWarp}>
        <div className={css.FormBody}>
          { withLocation &&
            <div className={css.originInput}> 
              <LocationInput2
                id={`${id}-origin`}
                label='ORIGIN'
                name='origin'
                placeholder='City'
                icon={'greenPlace'}
                autoComplete = 'off'
                iconLeft={true}
                touched={true}
                searchedCity={hasOrigin && origin ? origin.name : ''}
                onChange = {(param)=>this.handleChange("origin", param)}
                onBlur = {(param)=>{
                  this.handleChange("origin", param.data.placeValue)
                  this.handleBlur("origin")
                }}
                error={error.origin ? error.origin : ' '}
              />
            </div>
          }
          { withLocation && 
            <div className={css.destinationInput}>
              <LocationInput2
                id={`${id}-destination`}
                label='DESTINATION'
                icon={'bluePlace'}
                name='destination'
                iconLeft={true}
                autoComplete = 'off'
                touched={true}
                placeholder='City'
                searchedCity={hasDestination && destination ? destination.name : ''}
                onChange = {(param)=>this.handleChange("destination", param)}
                onBlur = {(param)=>{
                  this.handleChange("destination", param.data.placeValue)
                  this.handleBlur("destination")
                }}
                error={error.destination ? error.destination : ' '}
              />
            </div>
          }
          <div className={css.fuelCostInput}>
            <LabeledInput
              name='fuelPrice'
              label='FUEL COST PER GALLON'
              placeholder=''
              autoComplete = 'off'
              touched={true}
              icon={'dollar'}
              iconLeft={true}
              value={fuelPrice || ''}
              error={error.fuelPrice ? error.fuelPrice : ' '}
              onBlur={(element)=>this.handleBlur("fuelPrice",element.currentTarget.value)}
              onChange={(element)=>this.handleChange("fuelPrice", element.currentTarget.value)}
              onMount={this.handleFuelPriceInputMount}
            />
            <div className={css.fuelCostHintPosition}>
              <FuelCostHint onHintClick={this.handleFuelPriceHintClick}></FuelCostHint>
            </div>
          </div>
          <div className={css.basePriceInput}>
            <LabeledInput
              name='basePrice'
              label='BASELINE FUEL PRICE'
              touched={true}
              icon={'dollar'}
              autoComplete = 'off'
              iconLeft={true}
              value={basePrice || ''}
              error={error.basePrice ? error.basePrice : ' '}
              onBlur={(element)=>this.handleBlur("basePrice",element.currentTarget.value)}
              onChange={(element)=>this.handleChange("basePrice", element.currentTarget.value)}
            />
          </div>
          <div className={css.milesPriceInput}>
            <LabeledInput
              name='milesPrice'
              label='MILES PER GALLON'
              autoComplete = 'off'
              touched={true}
              value={milesPrice || ''}
              error={error.milesPrice ? error.milesPrice : ' '}
              onBlur={(element)=>this.handleBlur("milesPrice",element.currentTarget.value)}
              onChange={(element)=>this.handleChange("milesPrice", element.currentTarget.value)}
            />
          </div>
        </div>
        <div className={css.button}>
          <Button onClick={this.handleSubmit} mods={['wide', 'action']}>
            Calculate
          </Button>
        </div>
      </div>
    )
  }

  renderResult() {
    const {
      distance,
      estFuelPerMile,
      estFuelCost,
      fuelRateMile,
      totalFuel,
      milesPrice,
    } = this.state;
    const {
      isMember,
      showUpgradeToPremium
    } = this.props;
    return (
      <div>
        <div className={css.resultTitle}>
          <div className={css.resultBr}></div> 
          <div className={css.resultTitleContent}>Estimated Fuel Cost at {milesPrice} MPG</div> 
          <div className={css.resultBr}></div> 
        </div>
        {
          !isMember && 
          <Unlock
            onClick={showUpgradeToPremium}
          ></Unlock>
        }
        <div className={cs(css.resultContent, css.resultContentRow1)}>
          <div className={css.resultContentItem}>
            <div className={css.resultContentTitle}>
              Est.Fuel Cost / Mile
            </div> 
            <div className={css.resultContentNumber}>
              <span>$ </span>
              <span className={css.resultContentNumberStrong}>{formatNumber(estFuelCost,isMember)}</span>
            </div> 
          </div>
          <div className={css.resultContentItem}>
            <div className={css.resultContentTitle}>
              Distance
            </div> 
            <div className={css.resultContentNumber}>
              <span className={css.resultContentNumberStrong}>{formatNumber(distance,isMember)}</span>
              <span> mi</span>
            </div> 
          </div>
          <div className={css.resultContentItem}>
            <div className={css.resultContentTitle}>
              Est. Fuel Cost
            </div> 
            <div className={css.resultContentNumber}>
              <span>$ </span>
              <span className={css.resultContentNumberStrong}>{formatNumber(estFuelPerMile,isMember)}</span>
            </div> 
          </div>
        </div>
        <div className={css.resultTitle}>
          <div className={css.resultBr}></div> 
          <div className={css.resultTitleContent}>Fuel Surcharge Calculate</div> 
          <div className={css.resultBr}></div> 
        </div>
        {
          !isMember && 
          <Unlock
            onClick={showUpgradeToPremium}
          ></Unlock>
        }
        <div className={cs(css.resultContent, css.resultContentRow2)}>
          <div className={css.resultContentItem}>
            <div className={css.resultContentTitle}>
              Fuel Surcharge Rate / Mile
            </div> 
            <div className={cs(css.resultContentNumber, css.resultContentNumberBule)}>
              <span>$ </span>
              <span className={css.resultContentNumberStrong}>{formatNumber(fuelRateMile,isMember)}</span>
            </div> 
          </div>
          <div className={css.resultContentItem}>
            <div className={css.resultContentTitle}>
              Total Fuel Surcharge
            </div> 
            <div className={cs(css.resultContentNumber, css.resultContentNumberBule)}>
              <span>$ </span>
              <span className={css.resultContentNumberStrong}>{formatNumber(totalFuel,isMember)}</span>
            </div> 
          </div>
        </div>
      </div>
    )
  }

  render() {
    return(
      <div>
        {this.renderForm()}
        {this.renderResult()}
      </div>
    )
  }
}

export default connect(({account})=>{
  return {
    isMember: parseInt(account.accountLevel) >= parseInt(account.premium),
  }
},mapDispatch({
  showUpgradeToPremium: (props) => modalChange('pop', {
    source: "",
    type: 'pop_upgrade_to_premium',
  }),
}))(FuelSurcharge)



// WEBPACK FOOTER //
// ./src/components/common/FuelSurcharge/index.js